import React from 'react';
import Button from '../../../../components/Button/Button';
import { useDeleteSectionMutation } from '../../../../services/plaintiffSheets/plaintiffSheetsEndpoint';
import { ISectionItem } from '../../../../services/plaintiffSheets/plaintiffSheetsTypes';
import { useToast } from '../../../../components/Toast/ToastContext';

interface IDeleteSectionProps {
  closePopUp: () => void;
  data?: ISectionItem;
  factSheetId: string;
}

const DeleteSection: React.FC<IDeleteSectionProps> = ({ closePopUp, data, factSheetId }) => {
  const { addToast } = useToast();
  const [deleteSection, { isLoading }] = useDeleteSectionMutation();

  const handleDelete = async () => {
    try {
      const response = await deleteSection({
        factSheetId,
        sectionId: data?.section_id ?? '',
      }).unwrap();
      if (response) {
        addToast('Section Deleted', 'Section is Deleted successfully.', 'success');
      }
      closePopUp();
    } catch (error) {
      addToast('Section Deletion Failed', 'Failed to delete section. Please try again. ', 'error');
    }
  };

  return (
    <div>
      <p className="text-md text-ds-gray-500">
        Are you sure you want to delete this section? Deleting it will remove all fields within this
        section permanently. This action cannot be undone.
      </p>

      <div className="mt-4 flex justify-end gap-2">
        <Button onClick={closePopUp} disabled={isLoading}>
          Cancel
        </Button>
        <Button color="error" type="button" onClick={handleDelete} loading={isLoading}>
          Delete
        </Button>
      </div>
    </div>
  );
};

export default DeleteSection;
